import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OpenDataService } from '../../services/open-data.service';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { PagingService } from '../../../../shared/Services/PagingService';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { AddOpenDataComponent } from '../add-open-data/add-open-data.component';
import * as momentHijri from 'moment-hijri';
import { GetOpenDataDetailsComponent } from '../get-open-data-details/get-open-data-details.component';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'get-open-data',
  templateUrl: './get-open-data.component.html',
  styleUrls: ['./get-open-data.component.scss']
})
export class GetOpenDataComponent extends BaseComponent implements OnInit {
form: FormGroup;
    constructor(
      public service: OpenDataService,
      route: Router,
      private diag: NbDialogService,
      private toast: NbToastrService,
      private fb: FormBuilder,
      private paging: PagingService
    ) {
      super(route, service, paging);
    }

   ngOnInit() {
      this.intitForm();
      this.loadEntities();
    }

    loadEntities() {
      if (this.isAuthorized) {
        this.service.get(this.pagingModel.query).subscribe(
          (res) => {
            this.initiResponse(res);
            this.finishLoading = true;
          },
          () => {
            this.finishLoading = true;
          }
        );
      }
    }
  
    intitForm() {
      this.form = this.fb.group({
        keyAR: [''],
      });
    }
  
  handleSearch() {
    if (!this.form.value.keyAR) {
      this.toast.danger('برجاء إدخال المفتاح لإتمام عملية البحث', 'رسالة تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.keyAR.trim()) {
      let title = this.form.value.keyAR.trim();
      this.form.controls['keyAR'].setValue(title);
      serchTermArr.push(`keyAR:${title}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
    clearFilter() {
      this.form.controls['keyAR'].setValue('');
      this.loadEntitiesWithFilter('');
    }
  
    addOpenData() {
      this.diag
        .open(AddOpenDataComponent, {
          dialogClass: 'custom-dialog-height',
        })
        .onClose.subscribe((res) => {
          if (res === 'true') this.loadEntities();
        });
    }
  
  delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }
  
    detail(model) {
      this.diag.open(GetOpenDataDetailsComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: model,
        },
      });
    }
  
    update(model) {
      const copymodel = {...model}
      this.diag
        .open(AddOpenDataComponent, {
          dialogClass: 'custom-dialog-height',
          context: {
            model: copymodel,
            isEdit: true,
          },
        })
        .onClose.subscribe((res) => {
          if (res === 'true') this.loadEntities();
        });
    }
  
    initiResponse(result: any) {
      this.pagingModel.responseObj = result.result;
      this.pagingModel.responseData = result;
      this.pagingModel.pager = Array.from({ length: result.totalPages }, (v, k) => k + 1);
      this.pagingModel.totalPages = result.totalPages;
      return this.pagingModel;
    }

    getHijriDate(date) {
      return momentHijri(date, 'YYYY-MM-DD').format('iYYYY/iM/iD');
     }
}